
const Footer = () => {
  const handleNewsletterSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    const form = e.currentTarget;
    const formData = new FormData(form);
    
    try {
      const response = await fetch('https://readdy.ai/api/form/d58k16misj01hmefqtpg', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
        },
        body: new URLSearchParams(formData as any).toString(),
      });

      if (response.ok) {
        alert('تم الاشتراك بنجاح!');
        form.reset();
      }
    } catch (error) {
      console.error('Error:', error);
    }
  };

  return (
    <footer className="bg-black text-white rounded-t-[40px] mt-20 relative overflow-hidden">
      {/* Decorative Background Text */}
      <div className="absolute bottom-4 right-8 text-[120px] font-bold opacity-5 pointer-events-none whitespace-nowrap">
        خياط الأقمشة الكويتية
      </div>

      <div className="container mx-auto px-6 py-16 relative z-10">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-12">
          {/* Column 1 - Logo & CTA */}
          <div className="md:col-span-1">
            <div className="mb-6">
              <img 
                src="https://static.readdy.ai/image/8f4b99b6f50522f57c0c4089909ec764/4083781e1a34b23bac118fadb1fef617.png" 
                alt="خياط الأقمشة الكويتية" 
                className="h-20 w-auto mb-4"
              />
            </div>
            <h3 className="text-3xl font-bold mb-2">جاهزون لخدمتك</h3>
            <p className="text-lg text-gray-300">تواصل معنا اليوم</p>
          </div>

          {/* Column 2 - Quick Links */}
          <div>
            <h4 className="text-xl font-bold mb-6">روابط مهمة</h4>
            <ul className="space-y-3">
              <li>
                <a href="/fabrics" className="text-gray-300 hover:text-secondary transition-colors cursor-pointer">
                  الأقمشة
                </a>
              </li>
              <li>
                <a href="/tailoring" className="text-gray-300 hover:text-secondary transition-colors cursor-pointer">
                  التفصيل
                </a>
              </li>
              <li>
                <a href="/measurements" className="text-gray-300 hover:text-secondary transition-colors cursor-pointer">
                  المقاسات
                </a>
              </li>
              <li>
                <a href="/" className="text-gray-300 hover:text-secondary transition-colors cursor-pointer">
                  من نحن
                </a>
              </li>
              <li>
                <a href="/" className="text-gray-300 hover:text-secondary transition-colors cursor-pointer">
                  سياسة الخصوصية
                </a>
              </li>
            </ul>
          </div>

          {/* Column 3 - Social Media */}
          <div>
            <h4 className="text-xl font-bold mb-6">تابعنا</h4>
            <ul className="space-y-3">
              <li>
                <a
                  href="https://instagram.com"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="flex items-center gap-3 text-gray-300 hover:text-secondary transition-colors cursor-pointer"
                >
                  <i className="ri-instagram-line text-xl"></i>
                  <span>إنستغرام</span>
                </a>
              </li>
              <li>
                <a
                  href="https://wa.me/96512345678"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="flex items-center gap-3 text-gray-300 hover:text-secondary transition-colors cursor-pointer"
                >
                  <i className="ri-whatsapp-line text-xl"></i>
                  <span>واتساب</span>
                </a>
              </li>
              <li>
                <a
                  href="https://twitter.com"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="flex items-center gap-3 text-gray-300 hover:text-secondary transition-colors cursor-pointer"
                >
                  <i className="ri-twitter-x-line text-xl"></i>
                  <span>تويتر</span>
                </a>
              </li>
            </ul>
          </div>

          {/* Column 4 - Newsletter */}
          <div>
            <h4 className="text-xl font-bold mb-2">اشترك في نشرتنا</h4>
            <p className="text-gray-300 mb-4">لآخر العروض</p>
            <form onSubmit={handleNewsletterSubmit} className="relative" data-readdy-form id="newsletter-form">
              <input
                type="email"
                name="email"
                placeholder="بريدك الإلكتروني"
                required
                className="w-full bg-black border border-gray-600 text-white px-4 py-3 rounded-full focus:outline-none focus:border-secondary"
              />
              <button
                type="submit"
                className="absolute left-2 top-1/2 -translate-y-1/2 bg-white text-black w-10 h-10 rounded-full flex items-center justify-center hover:bg-secondary hover:text-white transition-all cursor-pointer whitespace-nowrap"
              >
                <i className="ri-arrow-left-line"></i>
              </button>
            </form>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-gray-800 mt-12 pt-8 text-center">
          <p className="text-gray-400 text-sm">
            © 2025 خياط الأقمشة الكويتية. جميع الحقوق محفوظة.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
